/**
 *都道府県の画面用文字列リスト
 */
const PREFECTURE_CODE_LIST = [
  { num: "01", name: "北海道" },
  { num: "02", name: "青森県" },
  { num: "03", name: "岩手県" },
  { num: "04", name: "宮城県" },
  { num: "05", name: "秋田県" },
  { num: "06", name: "山形県" },
  { num: "07", name: "福島県" },
  { num: "08", name: "茨城県" },
  { num: "09", name: "栃木県" },
  { num: "10", name: "群馬県" },
  { num: "11", name: "埼玉県" },
  { num: "12", name: "千葉県" },
  { num: "13", name: "東京都" },
  { num: "14", name: "神奈川県" },
  { num: "15", name: "新潟県" },
  { num: "16", name: "富山県" },
  { num: "17", name: "石川県" },
  { num: "18", name: "福井県" },
  { num: "19", name: "山梨県" },
  { num: "20", name: "長野県" },
  { num: "21", name: "岐阜県" },
  { num: "22", name: "静岡県" },
  { num: "23", name: "愛知県" },
  { num: "24", name: "三重県" },
  { num: "25", name: "滋賀県" },
  { num: "26", name: "京都府" },
  { num: "27", name: "大阪府" },
  { num: "28", name: "兵庫県" },
  { num: "29", name: "奈良県" },
  { num: "30", name: "和歌山県" },
  { num: "31", name: "鳥取県" },
  { num: "32", name: "島根県" },
  { num: "33", name: "岡山県" },
  { num: "34", name: "広島県" },
  { num: "35", name: "山口県" },
  { num: "36", name: "徳島県" },
  { num: "37", name: "香川県" },
  { num: "38", name: "愛媛県" },
  { num: "39", name: "高知県" },
  { num: "40", name: "福岡県" },
  { num: "41", name: "佐賀県" },
  { num: "42", name: "長崎県" },
  { num: "43", name: "熊本県" },
  { num: "44", name: "大分県" },
  { num: "45", name: "宮崎県" },
  { num: "46", name: "鹿児島県" },
  { num: "47", name: "沖縄県" },
];
/**
 *道路種別の画面用文字列リスト
 */
const ROAD_TYPE_LIST = [
  { num: "1", name: "高速自動車国道" },
  { num: "2", name: "都市高速道路（含指定都市高速道路）" },
  { num: "3", name: "一般国道" },
  { num: "4", name: "主要地方道（都道府県道）" },
  { num: "5", name: "主要地方道（指定市道）" },
  { num: "6", name: "一般都道府県道" },
  { num: "7", name: "指定市の一般市道" },
  { num: "8", name: "それ以外" },
  { num: "9", name: "その他の道路" },
  { num: "0", name: "未調査" },
];
/**
 *上り・下りコードの画面用文字列リスト
 */
const UP_DOWN_CODE_LIST = [
  { num: "0", name: "不明" },
  { num: "1", name: "上り" },
  { num: "2", name: "下り" },
];
/**
 *休平日区分の画面用文字列リスト
 */
const HORIDAY_CODE_LIST = [
  { num: "1", name: "平日" },
  { num: "2", name: "休日" },
  { num: "3", name: "全日" },
];
/**
 *確定フラグの画面用文字列リスト
 */
const CONFIRUM_FLAG_LIST = [
  { num: "0", name: "未確定" },
  { num: "1", name: "確定" },
];
/**
 *測地系コードの画面用文字列リスト
 */
const GEODET_CODE_LIST = [
  { num: "0", name: "日本座標系" },
  { num: "1", name: "世界座標系" },
];
/**
 *管理者コードの画面用文字列リスト
 */
const ADMIN_CODE_LIST = [
  { num: "1", name: "都市間高速（NEXCO）" },
  { num: "2", name: "都市内高速（本四含む）" },
  { num: "3", name: "道路公社" },
  { num: "4", name: "国" },
  { num: "5", name: "都道府県" },
  { num: "6", name: "指定市" },
  { num: "7", name: "他の市町村（含東京23区）" },
  { num: "8", name: "その他" },
  { num: "0", name: "未調査" },
];
/**
 *原データコードの画面用文字列リスト
 */
const SPECIFICATIONS_CODE_LIST = [
  { num: "1", name: "道路プローブ" },
  { num: "2", name: "民間プローブ" },
  { num: "3", name: "両プローブ使用" },
  { num: "4", name: "その他" },
];
export class ETCCodeUtil {
  /**
   * 都道府県を画面用文字列に変換する
   */
  public static toPrefectureCodeViewString(code: string) {
    if (code === null || code === "" || code === undefined) {
      return "-";
    }
    const prefecture = PREFECTURE_CODE_LIST.find(
      (element) => element.num == code
    );
    if (!prefecture) {
      return code + "（未定義）";
    } else {
      return prefecture.num + "（" + prefecture.name + "）";
    }
  }

  /**
   * 道路種別を画面用文字列に変換する
   */
  public static toRoadTypeViewString(code: string) {
    if (code === null || code === "" || code === undefined) {
      return "-";
    }
    const roadType = ROAD_TYPE_LIST.find((element) => element.num == code);
    if (!roadType) {
      return code + "（未定義）";
    } else {
      return roadType.num + "（" + roadType.name + "）";
    }
  }
  /**
   * 上り・下りコードを画面用文字列に変換する
   */
  public static toUpDownCodeViewString(code: string) {
    if (code === null || code === "" || code === undefined) {
      return "-";
    }
    const upDownCode = UP_DOWN_CODE_LIST.find((element) => element.num == code);
    if (!upDownCode) {
      return code + "（未定義）";
    } else {
      return upDownCode.num + "（" + upDownCode.name + "）";
    }
  }
  /**
   * 休平日区分を画面用文字列に変換する
   */
  public static toHoridayCodeViewString(code: string) {
    if (code === null || code === "" || code === undefined) {
      return "-";
    }
    const horidayCode = HORIDAY_CODE_LIST.find(
      (element) => element.num == code
    );
    if (!horidayCode) {
      return code + "（未定義）";
    } else {
      return horidayCode.num + "（" + horidayCode.name + "）";
    }
  }
  /**
   * 旅行速度算定根拠フラグを画面用文字列に変換する
   */
  public static toTravelViewString(_code: string) {
    return "1（固定）";
  }
  /**
   * 確定フラグを画面用文字列に変換する
   */
  public static toConfirumViewString(code: string) {
    if (code === null || code === "" || code === undefined) {
      return "-";
    }
    const confirum = CONFIRUM_FLAG_LIST.find((element) => element.num == code);
    if (!confirum) {
      return code + "（未定義）";
    } else {
      return confirum.num + "（" + confirum.name + "）";
    }
  }
  /**
   * 測地系コードを画面用文字列に変換する
   */
  public static toGeodetCodeViewString(code: string) {
    if (code === null || code === "" || code === undefined) {
      return "-";
    }
    const geodetCode = GEODET_CODE_LIST.find((element) => element.num == code);
    if (!geodetCode) {
      return code + "（未定義）";
    } else {
      return geodetCode.num + "（" + geodetCode.name + "）";
    }
  }
  /**
   * 管理者コードを画面用文字列に変換する
   */
  public static toAdminCodeViewString(code: string) {
    if (code === null || code === "" || code === undefined) {
      return "-";
    }
    const adminCode = ADMIN_CODE_LIST.find((element) => element.num == code);
    if (!adminCode) {
      return code + "（未定義）";
    } else {
      return adminCode.num + "（" + adminCode.name + "）";
    }
  }
  /**
   * 原データコードを画面用文字列に変換する
   */
  public static toSpecificationsViewString(code: string) {
    if (code === null || code === "" || code === undefined) {
      return "-";
    }
    const specifications = SPECIFICATIONS_CODE_LIST.find(
      (element) => element.num == code
    );
    if (!specifications) {
      return code + "（未定義）";
    } else {
      return specifications.num + "（" + specifications.name + "）";
    }
  }
}
